class RevealHeading extends window.HTMLElement {
    constructor() {
        super();
        this.spans = Array.from(this.children);
        this.firstColor = this.dataset.firstColor;
        this.secondColor = this.dataset.secondColor;
        this.lastColor = this.dataset.lastColor;
        this.updateAnimation = this.updateAnimation.bind(this);
        this.initConfig = this.initConfig.bind(this);
        this.initConfig();
    }

    initConfig() {
        this.spans.forEach((span) => {
            span.style.background = `linear-gradient(269deg, ${this.firstColor} 100%, ${this.secondColor} 144%, ${this.secondColor} 156%, ${this.lastColor} 200%) text`;
            span.style.webkitTextFillColor = "transparent";
        });

        new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        window.addEventListener("scroll", this.updateAnimation);
                    } else {
                        window.removeEventListener("scroll", this.updateAnimation);
                    }
                });
            },
            { threshold: 0 }
        ).observe(this);

        this.updateAnimation();
    }

    updateAnimation() {
        const rect = this.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        const center = rect.top + rect.height / 2;
        const start = 0.6 * windowHeight - rect.height / 2;
        const progress = Math.min(1, Math.max(0, (windowHeight - center) / (windowHeight - start)));

        const len = this.spans.length;
        this.spans.forEach((span, i) => {
            const s = i / len;
            const n = (i + 1) / len;
            let e = 0;
            if (progress >= n) e = 1;
            else if (progress > s) e = (progress - s) / (n - s);

            const h = 100 - 200 * e;
            const a = 144 - 200 * e;
            const l = 156 - 200 * e;
            const d = 200 - 200 * e;

            span.style.background = `linear-gradient(269deg, ${this.firstColor} ${h}%, ${this.secondColor} ${a}%, ${this.secondColor} ${l}%, ${this.lastColor} ${d}%) text`;
        });
    }
}

window.customElements.define("reveal-heading", RevealHeading);
